import React from 'react';
import { PropTypes } from 'prop-types';
import SubmitButton from '@atoms/SubmitButton';

export const Unlock = ({ onNext }) => (
    <div>
        <div className="container-fluid">
            <div className="row">
                <div
                    className="col-12 col-lg-8 p-4 d-flex flex-column align-items-center justify-content-center text-center"
                    style={{ minHeight: '400px' }}
                >
                    <h2>Unlock Connection Recommendations</h2>
                    <p className="mb-16">
                        Tell us what you're looking for and we'll create customized recommendations based on your
                        criteria.
                    </p>
                    <SubmitButton onClick={() => onNext({})}>Get Started</SubmitButton>
                </div>

                <div
                    className="col-12 col-lg-4"
                    style={{
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundImage: 'url(https://via.placeholder.com/400)',
                    }}
                />
            </div>
        </div>
    </div>
);

Unlock.propTypes = {
    onNext: PropTypes.func,
};
